exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PassengerDetailsInput_root_3NIJp {\n  background-color: #ffffff;\n  padding: 32px;\n}\n\n.PassengerDetailsInput_title_Qto2J {\n  font-size: 20px;\n  font-weight: 400;\n  text-align: center;\n}\n\n.PassengerDetailsInput_subtitle_SWDEW {\n  font-size: 13px;\n  margin: 8px auto;\n  max-width: 228px;\n  text-align: center;\n}\n\n.PassengerDetailsInput_contactItem_39ESs + .PassengerDetailsInput_contactItem_39ESs{\n  margin-top: 8px;\n}\n\n.PassengerDetailsInput_contactLink_69y1V {\n  color: #4a90e2;\n}\n\n.PassengerDetailsInput_capacity_35bxD {\n  max-width: 96px;\n  margin: 0 auto;\n}\n\n.PassengerDetailsInput_optionalRequirement_2auLj {\n  max-width: 250px;\n  margin: 0 auto;\n}\n\n.PassengerDetailsInput_optionalMessage_3dUwE {\n  color: #468ee5;\n  font-family: Roboto Condensed;\n  font-size: 13px;\n  border-top: 2px solid #468ee5;\n  padding-top: 8px;\n}\n\n.PassengerDetailsInput_optionalMessageClickable_1hfHf {\n  cursor: pointer;\n  text-decoration: underline;\n}\n", ""]);

// exports
exports.locals = {
	"root": "PassengerDetailsInput_root_3NIJp",
	"title": "PassengerDetailsInput_title_Qto2J",
	"subtitle": "PassengerDetailsInput_subtitle_SWDEW",
	"contactItem": "PassengerDetailsInput_contactItem_39ESs",
	"contactLink": "PassengerDetailsInput_contactLink_69y1V",
	"capacity": "PassengerDetailsInput_capacity_35bxD",
	"optionalRequirement": "PassengerDetailsInput_optionalRequirement_2auLj",
	"optionalMessage": "PassengerDetailsInput_optionalMessage_3dUwE",
	"optionalMessageClickable": "PassengerDetailsInput_optionalMessageClickable_1hfHf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/PassengerDetailsInput/PassengerDetailsInput.css
// module id = 1365
// module chunks = 1